import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
  } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NecCacheable } from '../cache/cacheable';
import { NecCacheService } from './../cache/cache.service';
import { Observable, of } from 'rxjs';

/**
 * å¯¹httpè¯·æ±è¿è¡ç¼å­çæ¦æªå¨
 */
@Injectable()
export class NecCacheInterceptor implements HttpInterceptor {

  constructor(
    private cacheService: NecCacheService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    /**
     * è¯»åè¯·æ±ä¸­çç¼å­åæ°, å¦ææªè®¾ç½®åè®¾ç½®ä¸ºé»è®¤å¼
     *
     * cache: æ¯å¦è®¾ç½®/è¯»åç¼å­, é»è®¤false
     * cacheLevel: ç¼å­ççº§å«(LOCALSTORAGE, MEMORY), é»è®¤MEMORY
     * expireTime: è¿ææ¶é´, é»è®¤24å°æ¶ = 86400000æ¯«ç§
     * flush: æ¯å¦å¼ºå¶å·æ°ç¼å­, é»è®¤false
     */
    const cache = request.headers.get('cache') || false;
    const cacheLevel = request.headers.get('cacheLevel') || 'MEMORY';
    const expireTime = Number.parseInt(request.headers.get('expireTime')) || 86400000;
    const flush = request.headers.get('flush') || false;

    // è¯·æ±éè¦ç¼å­ & æªå¼ºå¶å·æ° & ç¼å­å½ä¸­ & æªè¿æ => ç´æ¥è¿åç¼å­ä¸­çæ°æ®
    let key: string = this.cacheService.md5(request);
    if (cache && !flush && this.cacheService.get(key, cacheLevel)
      && !this.cacheService.expire(key, cacheLevel)) {
      return of(new HttpResponse({
        body: this.cacheService.get(key, cacheLevel).data,
        status: 200
      }));
    }

    // å¶ä½æåµ, åéè¯·æ±è·åæ°æ® => å·æ°ç¼å­
    let headers = new HttpHeaders();
    for (let header of request.headers.keys()) {
      switch (header) {
        case 'cache':
        case 'cacheLevel':
        case 'expireTime':
        case 'flush':
          break;
        default:
          headers = headers.append(header, request.headers.get(header));
      }
    }

    request = request.clone({
      headers: headers
    });
    return next.handle(request).pipe(map(response => {
      if (cache && response instanceof HttpResponse) {
        const currentTime = new Date().getTime();
        this.cacheService.put(key, new NecCacheable(response.body, currentTime + expireTime), cacheLevel);
      }
      return response;
    }));
  }
}
